const indexItems = [
  { title: '红桃视频热门连载', count: '48部', tag: '连载中' },
  { title: '小蓝视频经典合集', count: '156部', tag: '已完结' },
  { title: '黑桃视频精选剧场', count: '89部', tag: '更新中' },
  { title: '91视频都市专题', count: '72部', tag: '专题' },
  { title: '97视频4K片库', count: '320部', tag: '4K' },
  { title: '久久视频典藏', count: '204部', tag: '典藏' },
  { title: '梅花视频人气榜', count: '63部', tag: '人气' },
  { title: '白桃视频新番速递', count: '41部', tag: '新番' },
  { title: '绿萝视频精选频道', count: '95部', tag: '精选' },
];

export default function IndexSection() {
  return (
    <section id="index" className="relative py-14 md:py-20 bg-background-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-primary-400 font-medium tracking-wider uppercase mb-2">Index</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">频道索引</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">妖精视频全数字颜色系列频道内容目录，快速定位你想看的</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="flex items-center gap-4 bg-background-800/40 border border-background-700/30 rounded-lg p-4 md:p-5 hover:border-primary-500/20 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/15 transition-colors duration-200 shrink-0">
                <i className="ri-play-list-2-line text-lg"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-200 group-hover:text-foreground-50 transition-colors duration-200 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-600 mt-0.5">{item.count}</p>
              </div>
              <span className="text-xs px-2 py-1 rounded-full bg-accent-500/10 text-accent-400 whitespace-nowrap shrink-0">{item.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}